<div class="menu">
  <div class="navigation navigation-scrollable">
    <ul nz-menu [nzMode]="'horizontal'" [ngStyle]="{'white-space': 'nowrap'}">
      @for (item of (menuDataChildrenActivated ?? []); track item.url) {
        @if (hasAccess(item)) {
          <li class="ant-menu-item ng-star-inserted" routerLinkActive="ant-menu-item-selected">
            <a routerLink={{item.url}} title="{{ item.title }}">
              <span class="title">{{ item.title }}</span>
            </a>
          </li>
        } @else {
          @if (display(item)) {
            <li class="ant-menu-item ng-star-inserted">
              <a title="{{ item.title }}" class="disabled">
                <span class="title">{{ item.title }}</span>
              </a>
            </li>
          }
        }
      }
    </ul>
  </div>
</div>
